import React from 'react';

import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { SectionContentDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import { TrackerExtraInfoProps } from '@diritto/common/tracker/tracking-event.constant';
import { SectionContentTextsBase } from 'app-components/home/sections/components/SectionContentTextsBase';
import { SectionContentTextItem } from 'app-components/home/sections/items/SectionContentTextItem';

type SectionProps = {
  section: SectionContentDto;
  contents: Record<number, ContentRelayDto>;
  profileLites: Record<number, ProfileLiteRelayDto>;
};

const ITEMS_PER_COLUMN = 4;

export const SectionContentTexts = ({
  section,
  contents,
  profileLites,
  trackerExtraInfo,
}: SectionProps & TrackerExtraInfoProps) => (
  <SectionContentTextsBase
    section={section}
    contents={contents}
    profileLites={profileLites}
    trackerExtraInfo={trackerExtraInfo}
    itemsPerColumn={ITEMS_PER_COLUMN}
    ItemComponent={SectionContentTextItem}
  />
);

export default SectionContentTexts;
